var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonUnfilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73223 8.23223C3.20107 7.76339 3.83696 7.5 4.5 7.5H8.5C9.16304 7.5 9.79893 7.76339 10.2678 8.23223C10.7366 8.70107 11 9.33696 11 10V11C11 11.2761 10.7761 11.5 10.5 11.5C10.2239 11.5 10 11.2761 10 11V10C10 9.60218 9.84197 9.22064 9.56066 8.93934C9.27936 8.65803 8.89782 8.5 8.5 8.5H4.5C4.10218 8.5 3.72064 8.65803 3.43934 8.93934C3.15804 9.22064 3 9.60218 3 10V11C3 11.2761 2.77614 11.5 2.5 11.5C2.22386 11.5 2 11.2761 2 11V10C2 9.33696 2.26339 8.70107 2.73223 8.23223Z",
    fill: "#E5E4EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49994 2.5C5.67151 2.5 4.99994 3.17157 4.99994 4C4.99994 4.82843 5.67151 5.5 6.49994 5.5C7.32837 5.5 7.99994 4.82843 7.99994 4C7.99994 3.17157 7.32837 2.5 6.49994 2.5ZM3.99994 4C3.99994 2.61929 5.11923 1.5 6.49994 1.5C7.88065 1.5 8.99994 2.61929 8.99994 4C8.99994 5.38071 7.88065 6.5 6.49994 6.5C5.11923 6.5 3.99994 5.38071 3.99994 4Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonUnfilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-unfilled.b23edb715fd400390baa9712aff0cb87.svg";